import { render } from "./cms-pii-text.vue?vue&type=template&id=3dfb4512"
import script from "./cms-pii-text.vue?vue&type=script&lang=js"
export * from "./cms-pii-text.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__